export interface FishItem {
    id: string;
    name: string;
    description: string;
    rarity: 'common' | 'uncommon' | 'rare' | 'trash';
    value: number; // Gold value
    icon?: string;
}

export const fishItems: FishItem[] = [
    { id: 'fish_bass', name: 'Bass', description: 'A common freshwater fish.', rarity: 'common', value: 15, icon: '🐟' },
    { id: 'fish_trout', name: 'Trout', description: 'A spirited river fish.', rarity: 'common', value: 20, icon: '🐟' },
    { id: 'fish_salmon', name: 'Salmon', description: 'Prized for its flavor.', rarity: 'uncommon', value: 40, icon: '🐠' },
    { id: 'fish_koi', name: 'Golden Koi', description: 'A rare, lucky fish.', rarity: 'rare', value: 150, icon: '🎏' },
    { id: 'trash_boot', name: 'Old Boot', description: 'Someone lost this.', rarity: 'trash', value: 0, icon: '👢' },
    { id: 'trash_can', name: 'Rusty Can', description: 'Recycle please.', rarity: 'trash', value: 0, icon: '🥫' }
];
